// extracted by mini-css-extract-plugin
export default {"App":"App_App__VlQyM","welcomeText":"App_welcomeText__AQyDk","welcomeLine1":"App_welcomeLine1__jpWvC","welcomeLine2":"App_welcomeLine2__0uwOV"};